import axios from 'axios';
//const baseUrl = '/api/login';
//const baseUrl = 'http://10.20.2.36:6081/api/login';
//!!!!!const baseUrl = 'http://mcadex.savcor.com:6081/api/login'; // TÄMÄ ON OIKEA!
//const baseUrl = 'https://mcadex.savcor.com/api/login'; // TÄMÄ ON OIKEA!

//const baseUrl = 'http://10.20.2.36:6087/api/login'; // TILT KEHITYSYMPÄRISTÖ
const baseUrl = 'https://wireless.savcor.com/api/login'; // TILT MCADEX.SAVCOR.COM -> WIRELESS.SAVCOR.COM

const login = async (credentials) => {

    //console.log('heippa loginista')
    console.log('login', credentials)
    const response = await axios.post(baseUrl, credentials);
    console.log('login heippa response', response)
    return response.data
}

export default login;
/*


import React from 'react'
import { useState } from 'react';



const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    return (
        <>
        <h2>Login</h2>
            <form onSubmit="{handleLogin}">
                <div>
                    username
                        <input
                            type="text"
                            value={username}
                            name="Username"
                            onChange={({ target }) => setUsername(target.value)}
                    />
                </div>
                <div>
                    Password
                    <input
                        type="password"
                        value={password}
                        name="Password"
                        onChange={({ target }) => setPassword=(target.value)}
                        />
                        
                </div>
            </form>
        </>   
    )
}

export default Login
*/